import { render, staticRenderFns } from "./AppAutocompleteWithApi.vue?vue&type=template&id=0740afc0&"
import script from "./AppAutocompleteWithApi.vue?vue&type=script&lang=js&"
export * from "./AppAutocompleteWithApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAutocomplete,VIcon})
